import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API });

export const fetchPrinters = (params = {}) => http.get("/printers", { params }).then(r => r.data);
export const fetchPrinter = (slug) => http.get(`/printers/${slug}`).then(r => r.data);
export const fetchFacets = () => http.get("/printers/facets").then(r => r.data);
export const fetchCompare = (ids) => http.get("/printers/compare", { params: { ids: ids.join(",") } }).then(r => r.data);
export const fetchBlog = (params = {}) => http.get("/blog", { params }).then(r => r.data);
export const fetchArticle = (slug) => http.get(`/blog/${slug}`).then(r => r.data);
export const submitLead = (payload) => http.post("/leads", payload).then(r => r.data);
export const fetchFaqs = (params = {}) => http.get("/faqs", { params }).then(r => r.data);
export const fetchFaqCategories = () => http.get("/faqs/categories").then(r => r.data);
